import { PlaygroundVertex } from '../objects/PlaygroundVertex';

export class PlaygroundVertexList {
	first: PlaygroundVertex | null = null;
	last: PlaygroundVertex | null = null;
	length = 0;
	isClosed = false;

	add(vertex: PlaygroundVertex) {
		if (!this.first) {
			this.first = vertex;
			this.last = vertex;
		} else {
			if (!this.last) return;

			this.last.next = vertex;
			vertex.prev = this.last;
			this.last = vertex;
		}

		this.length++;
	}

	remove(vertex: PlaygroundVertex) {
		if (this.isClosed) this.openLoop();

		if (vertex.prev) vertex.prev.next = null;
		if (vertex.next) vertex.next.prev = null;

		if (this.first === vertex) this.first = vertex.next;
		if (this.last === vertex) this.last = vertex.prev;

		this.length--;

		vertex.dispose();
	}

	clear() {
		this.forEach((v) => v.dispose());
		this.first = null;
		this.last = null;
		this.length = 0;
		this.isClosed = false;
	}

	closeLoop() {
		if (!this.first || !this.last || this.length < 3) return;

		this.last.next = this.first;
		this.first.prev = this.last;
		this.isClosed = true;
	}

	openLoop() {
		this.isClosed = false;
	}

	forEach(callback: (v: PlaygroundVertex) => void) {
		let current = this.first;
		const visited = new Set<PlaygroundVertex>();

		while (current && !visited.has(current)) {
			callback(current);
			visited.add(current);
			current = current.next;
		}
	}

	toArray() {
		const arr: PlaygroundVertex[] = [];
		this.forEach((v) => arr.push(v));

		return arr;
	}

	export() {
		return this.toArray().map((v) => v.export());
	}

	isLoopClosed() {
		return this.isClosed;
	}
}
